import Form from "./form";
import { AttendanceLocalDepartment } from "../../../../../../../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentSchedule } from "../../../../../../../../../../../@types/attendance-local-department-schedule";
import { useAttendanceLocalDepartmentScheduleUpdate } from "../../../../../../../../../../../services/api-tansquery/attendance-local/department/schedule/update";

type FormUpdateProps = {
    departmentId: AttendanceLocalDepartment["id"];
    schedule: AttendanceLocalDepartmentSchedule;
    buttonTrigger?: React.ReactNode;
};

export default function FormUpdate(props: FormUpdateProps) {
    const mutation = useAttendanceLocalDepartmentScheduleUpdate(props.schedule.id);

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
